import { useQuery } from "@tanstack/react-query";
import api from "../utils/api";

export const fetchGetStudents = async ({ studyId, status, keyword }) => {
  // 쿼리 파라미터가 추가된 URL로 API를 호출합니다.
  const params = new URLSearchParams();
  if (keyword) {
    params.append("q", keyword); // 'q'는 일반적으로 검색 쿼리를 나타내는 파라미터입니다.
  }
  if (status) {
    params.append("status", status);
  }

  return await api.get(`/study-users/study/${studyId}?${params.toString()}`);
};

export const useGetStudentsQuery = ({ studyId, status, keyword }) => {
  return useQuery({
    queryKey: ["students", studyId?._id, status, keyword],
    enabled: !!studyId?._id,
    queryFn: () => fetchGetStudents({ studyId: studyId._id, status, keyword }),
    select: (data) => {
      return data.data.data;
    },
    keepPreviousData: true,
  });
};
